
import { RequestAssignedMaterialToPackage } from '../../../models/requestAssignedMaterialToPackage';
import { RequestPackages } from '../../../models/requestPackages';
import { RequestDetailEdit } from '../../../models/requestDetailEdit';


export class AssignMaterialsToPackagesController implements ng.IController  {

    static $inject = ['$mdMedia', '$mdDialog'];
    _editIndex: number;

    constructor(private _$mdMedia: angular.material.IMedia, private _$mdDialog: ng.material.IDialogService) {
    }

    $onInit() { };

isFormRequestedFromAddNewRequest: boolean;
    requestDetailEdit: RequestDetailEdit;
    

    get editIndex(): number {
        return this._editIndex;
    }

    get isAssignMaterialHasOnlyOnePackage() : boolean {
        if (this.isFormRequestedFromAddNewRequest && this.requestDetailEdit !== undefined &&
            this.requestDetailEdit.requestMaterial !== undefined &&
            this.requestDetailEdit.requestMaterial.requestPackages !== undefined &&
            this.requestDetailEdit.requestMaterial.requestPackages.filter(o => !o.isDeleted).length === 1){
            return true;
        }
        return false;
    }

    getAssignedPc(assignedPc: string, totalPc: string): string {
        if (assignedPc === undefined || assignedPc  === null) {
            return 0 + '/' + totalPc;
        }
        return assignedPc + '/' + totalPc;
    }

    getPackagesList(requestAssignedMaterial: RequestAssignedMaterialToPackage): string {
       var pkgList = '';
        if (requestAssignedMaterial !== undefined && requestAssignedMaterial.requestPackages !== undefined  && requestAssignedMaterial.requestPackages.length > 0) {
            pkgList = requestAssignedMaterial.requestPackages.
                filter(o => (o.quantity !== undefined && o.quantity !== null && o.quantity > 0 && !o.isDeleted)).map(o => o.packageType).join(' \n ');
       }
       
        return pkgList;
    }
    
    get isSubScrollContainer(): boolean {
        return this._$mdMedia('gt-md');
    }

    get isScrollContainer(): boolean {
        return this._$mdMedia('sm') || this._$mdMedia('md');
    }

    get isValid(): boolean {
        if (this.requestDetailEdit !== undefined &&
            this.requestDetailEdit.requestMaterial !== undefined &&
            this.requestDetailEdit.requestMaterial.requestAssignedMaterialToPackage !== undefined &&
            this.requestDetailEdit.requestMaterial.requestAssignedMaterialToPackage.length > 0 ) {
            let isAssignToMaterialPackagesValid: boolean = false;
            for (var iam = 0; iam < this.requestDetailEdit.requestMaterial.requestAssignedMaterialToPackage.length; iam++) {
                if (this.requestDetailEdit.requestMaterial.requestAssignedMaterialToPackage[iam] !== undefined &&
                    this.requestDetailEdit.requestMaterial.requestAssignedMaterialToPackage[iam].requestMaterials !== undefined &&
                    !this.requestDetailEdit.requestMaterial.requestAssignedMaterialToPackage[iam].requestMaterials.isDeleted) {

                    if (this.requestDetailEdit.requestMaterial.requestAssignedMaterialToPackage[iam]
                        .requestMaterials.quantity ===
                        this.requestDetailEdit.requestMaterial.requestAssignedMaterialToPackage[iam].assignedPc) {
                        isAssignToMaterialPackagesValid = true;
                    } else {
                        //isAssignToMaterialPackagesValid = false;
                        return false;
                    }

                }
            }

            return isAssignToMaterialPackagesValid;
        }
        return false;
    }

    set isValid(val: boolean) { }

    get showErrorMessageOnAssignMaterialsToPackagesInValidOnReceiverEditScreen() {
        if (!this.isFormRequestedFromAddNewRequest && !this.isValid) {
            return true;
        }
        return false;
    }
    
    editAssignToMaterials(event: MouseEvent, index: number): void {
        this._editIndex = index;
        

        this._$mdDialog.show({
            template: `<assign-materials-to-packages-dialog layout-fill
                            request-detail-edit="vm.requestDetailEdit"
                            edit-index="vm.editIndex">
                            </assign-materials-to-packages-dialog>`,

            parent: angular.element(document.body),
            targetEvent: event,
            onComplete: () => {
                angular.element(document.querySelector('md-dialog')).addClass('min-size-personnel');
            },
            controller: () => {},
            locals: {
                requestDetailEdit: this.requestDetailEdit,
                editIndex: this.editIndex
    },
            bindToController: true,
            controllerAs: 'vm'

        });
    }
}


/** WEBPACK FOOTER **
 ** ./DeliveryCreate/UI/app/features/request/requestDetailEdit/directives/assignMaterialsToPackages/controllers/assignMaterialsToPackagesController.ts
 **/